import { render, staticRenderFns } from "./CpButton.vue?vue&type=template&id=5c591646&scoped=true&"
import script from "./CpButton.vue?vue&type=script&lang=js&"
export * from "./CpButton.vue?vue&type=script&lang=js&"
import style0 from "./CpButton.vue?vue&type=style&index=0&id=5c591646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c591646",
  null
  
)

export default component.exports